import { Box, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { FSLink } from '@/ui/components/FSLink';
import { FSModal } from '@/ui/components/modal/FSModal';
import { FSModalTitle } from '@/ui/components/modal/FSModalTitle';
import { translate } from '@/ui/i18n';

export function Welcome() {
  const navigate = useNavigate();

  const navigateToApp = () => {
    navigate('/app', { replace: true });
  };

  return (
    <>
      <ModalWelcommeMessage onClose={navigateToApp} />
    </>
  );
}

function ModalWelcommeMessage({ onClose }: { onClose: () => void }) {
  return (
    <FSModal open={true} showCloseButton={true} onClose={onClose}>
      <MessageTileAndContent />
      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <FSPrimaryButton onClick={onClose}>
          {translate('Welcome.begin')}
        </FSPrimaryButton>
      </Box>
    </FSModal>
  );
}

// const SUBSCRIPTION_LINK = import.meta.env.VITE_URL_SUBSCRIPTION;
const SUBSCRIPTION_LINK = window.location.origin + '/app/contact';
const RESOURCES_LINK = import.meta.env.VITE_URL_MY_RESOURCES;
const MAILTO_LINK = import.meta.env.VITE_URL_MAILTO;

function MessageTileAndContent() {
  return (
    <Stack spacing={3}>
      <FSModalTitle title={translate('Welcome.title')} />
      <Typography>
        Vous êtes sur la version d’essai gratuit, pour découvrir toutes les
        fonctionnalités du mode événement.
      </Typography>
      <Typography>
        Vous avez la possibilité pendant 15 jours de créer un projet unique et
        pourrez à tout moment confirmer votre essai en allant dans votre{' '}
        <FSLink href={SUBSCRIPTION_LINK} target="_blank">
          section abonnement
        </FSLink>
        .
      </Typography>
      <Typography>
        Vous trouverez dans la section{' '}
        <FSLink href={RESOURCES_LINK} target="_blank">
          ressources
        </FSLink>{' '}
        une FAQ opérationelle pour vous accompagner dans la première utilisation
        de l’outil et des informations complémentaires sur le calcul de votre
        Fairly Score.
      </Typography>
      <Typography>
        Et pour toute question supplémentaire, écrivez nous à{' '}
        <FSLink href={MAILTO_LINK}>hello@fairly.run</FSLink>
      </Typography>
      <Typography>Bonne découverte de Fairly Score !</Typography>
    </Stack>
  );
}
